const PDFPreview = ({ src, title, minHeight = "100vh" }) => (
  <div>
    <iframe
      title={title}
      src={`${src}#zoom=FitH`}
      frameBorder="0"
      style={{ minHeight: minHeight}}
      width="100%"
      height="100%"
    />
  </div>
);

export default PDFPreview;
